import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';

const CashBack = () => {
  const { token } = useAuth(); // Get the admin token
  const [cashbackValue, setCashbackValue] = useState(null);
  const [newCashbackValue, setNewCashbackValue] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  // Fetch current cashback value
  useEffect(() => {
    const fetchCashback = async () => {
      try {
        const response = await api.get('/cashback', {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data?.cashback?.value) {
          setCashbackValue(response.data.cashback.value); // Set fetched cashback value
        } else {
          setError('Failed to fetch cashback value.');
        }
      } catch (err) {
        console.error(err);
        setError('Error fetching cashback value.');
      }
    };

    fetchCashback();
  }, [token]);

  // Handle cashback update
  const handleUpdate = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    try {
      // Convert percentage to decimal value before saving
      const decimalValue = parseFloat(newCashbackValue) / 100;

      if (isNaN(decimalValue) || decimalValue < 0) {
        setError('Invalid cashback value. Please enter a positive number.');
        return;
      }

      await api.put(
        '/cashback',
        { value: decimalValue },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCashbackValue(decimalValue); // Update state with new value
      setMessage('Cashback value updated successfully!');
      setNewCashbackValue(''); // Clear input field
    } catch (err) {
      console.error(err);
      setError('Failed to update cashback value.');
    }
  };

  return (
    <div className="flex flex-col md:flex-row">
      {/* Sidebar */}
      <Sidebar />

      {/* Content */}
      <div className="flex-1 bg-gray-50 p-4 md:p-6">
        <h2 className="text-lg md:text-2xl font-bold text-gray-700 mb-4">Cashback Manager</h2>

        {/* Current Cashback Value */}
        <div className="mb-6">
          <h3 className="text-md md:text-xl font-semibold mb-4">Current Cashback Value</h3>
          {cashbackValue !== null ? (
            <p className="text-lg font-medium">
              Cashback: <span className="text-black bg-primary p-2 rounded-lg  mt-4">{(cashbackValue * 100).toFixed(2)}%</span>
            </p>
          ) : (
            <p className="text-red-600">Loading cashback value...</p>
          )}
        </div>

        {/* Update Cashback Value Form */}
        <form onSubmit={handleUpdate} className="bg-white p-6 rounded-lg shadow-md">
          <div className="mb-4">
            <label className="block mb-1 font-medium">New Cashback Value (as percentage):</label>
            <input
              type="number"
              step="0.01"
              min="0"
              name="newCashbackValue"
              value={newCashbackValue}
              onChange={(e) => setNewCashbackValue(e.target.value)}
              required
              className="border border-gray-300 rounded-lg p-2 w-full focus:outline-none focus:ring focus:border-primary"
            />
          </div>
          <button
            type="submit"
            className="bg-primary text-black px-4 py-2 rounded-lg hover:bg-yellow-400"
          >
            Update Cashback
          </button>
        </form>

        {/* Messages */}
        {message && <p className="text-green-600 mt-4">{message}</p>}
        {error && <p className="text-red-600 mt-4">{error}</p>}
      </div>
    </div>
  );
};

export default CashBack;
